import { useLocation } from 'react-router';

import { LOGIN_REDIRECT_PARAM } from 'src/constants/auth';
import { resolveLoginRedirect, withLoginRedirect } from 'src/utils/loginRedirect';

const useRawRedirect = (): string | null => {
  const { search } = useLocation();
  return new URLSearchParams(search).get(LOGIN_REDIRECT_PARAM);
};

export const useLoginRedirectTarget = (): string => {
  const raw = useRawRedirect();
  return resolveLoginRedirect(raw);
};

export const useLoginUrl = (basePath: string): string => {
  const raw = useRawRedirect();
  return withLoginRedirect(basePath, raw);
};
